import { useState } from "react";
import { faqs } from "@/mocks/faqs";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="mx-auto w-full max-w-[1280px] px-4 py-14 md:px-6 md:py-16">
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-[0.8fr_1.6fr] lg:gap-14">
        <div>
          <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            常见问题
          </h2>
          <p className="mt-3 text-sm leading-7 text-foreground-600">
            第一次来黑料专区，最常见的问题都整理在这里。还有疑问可以在讨论区留言。
          </p>
          <span className="mt-5 inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3.5 py-1.5 text-xs font-medium text-secondary-700">
            <i className="ri-questionnaire-line"></i>
            共 {faqs.length} 个常见问题
          </span>
        </div>

        <div className="flex flex-col gap-3">
          {faqs.map((item, index) => {
            const isOpen = openIndex === index;
            return (
              <article
                key={item.q}
                className={`overflow-hidden rounded-lg border bg-background-50 transition-colors ${
                  isOpen ? "border-primary-300" : "border-background-200"
                }`}
              >
                <h3>
                  <button
                    type="button"
                    aria-expanded={isOpen}
                    onClick={() => setOpenIndex(isOpen ? null : index)}
                    className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                  >
                    <span className="font-heading text-base font-semibold text-foreground-950 md:text-lg">
                      {item.q}
                    </span>
                    <span
                      className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-colors ${
                        isOpen
                          ? "bg-primary-500 text-background-50"
                          : "bg-background-200 text-foreground-700"
                      }`}
                    >
                      <i className={isOpen ? "ri-subtract-line" : "ri-add-line"}></i>
                    </span>
                  </button>
                </h3>
                {isOpen && (
                  <p className="px-5 pb-5 text-sm leading-7 text-foreground-600">{item.a}</p>
                )}
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}